// Carimba o idioma DETECTADO na linha de user_profiles no momento em que ela
// nasce.
//
// O problema que isto resolve: `user_profiles.language` é a única fonte de
// idioma para todo push server-side, e nenhum dos dois caminhos que criam o
// perfil (Processing após o onboarding, AuthCallback no atalho direto pro
// Espelho) escrevia a coluna. Com o DEFAULT 'PT-BR' que a migration de 29/07
// consolidou, o silêncio do cliente virou uma afirmação: TODO usuário nasce
// português, inclusive quem chegou com o navegador em espanhol, polonês ou
// búlgaro. O default é a rede de segurança certa; ser o destino de todo mundo
// é o bug.
//
// Por que não basta pôr `language` no payload do upsert: os dois call sites
// usam `onConflict: "user_id"`, e o AuthCallback roda em TODO retorno de OAuth
// — não só no primeiro. Um `language` fixo no payload sobrescreveria, a cada
// login, a escolha consciente de quem já trocou de idioma nas Configurações.
// Daí a pré-checagem: só devolve o campo quando a linha AINDA NÃO EXISTE.
//
// Em erro de leitura devolve {} de propósito. O custo de não carimbar é o
// usuário cair no default e poder corrigir no seletor; o custo de carimbar por
// engano é apagar a escolha dele. Assimetria clara, escolha clara.

import { supabase } from "@/integrations/supabase/client";
import type { Lang } from "@/i18n/locale";

/**
 * Campo `language` para incluir no upsert que cria o perfil.
 *
 * @returns `{ language }` quando a linha não existe (perfil novo — carimbar),
 *          `{}` quando já existe ou quando a leitura falhou (nunca sobrescrever).
 */
export async function newProfileLanguagePatch(
  userId: string,
  lang: Lang,
): Promise<{ language?: Lang }> {
  try {
    const { data, error } = await supabase
      .from("user_profiles")
      .select("language")
      .eq("user_id", userId)
      .maybeSingle();

    if (error) {
      console.error("[profileLanguage] leitura do perfil falhou; não carimba", error);
      return {};
    }
    // Linha existente: o valor dela é do usuário, mesmo que seja o default.
    if (data) return {};

    return { language: lang };
  } catch (err) {
    console.error("[profileLanguage] leitura do perfil lançou; não carimba", err);
    return {};
  }
}
